<template>
  <v-row class="mt-n2" dense>
    <v-col v-for="campo in Object.keys (objetoFiltros)" :key="campo" md="3" sm="6" cols="12">
      <div class="caption font-weight-bold mt-0 mr-4">{{ definicionCampos [campo].titulo }}</div>
      <SelectorRangoFechasHoras
        v-if="definicionCampos [campo].tipo.toUpperCase() == 'DATETIME'"
        :titulo-dialogo="definicionCampos [campo].titulo"
        :titulo-visible="false"
        :background-color="colorFondo(campo)"
        :placeholder="$t ('(Seleccione una opción)')"
        :permitir-rango-sin-fecha-hora="!definicionCampos [campo].requerido"
        v-model="objetoFiltros[campo].seleccion"
        formatoModelo="ISO"
        @change="cambiosEnFiltro"
      />

      <v-autocomplete
        v-else-if="definicionCampos [campo].dominio_valores"
        class="mr-3 mb-0 mt-0"
        dense
        hide-details
        clearable
        return-object
        :background-color="colorFondo(campo)"
        :placeholder="$t ('(Seleccione una opción)')"
        :items="objetoFiltros[campo].itemsSelect"
        v-model="objetoFiltros[campo].seleccion"
        @change="cambiosEnFiltro"
      />

      <v-text-field
        v-else
        class="mr-3 mb-0 mt-0"
        dense
        hide-details
        clearable
        :placeholder="definicionCampos [campo].titulo"
        :maxlength="definicionCampos [campo].longitud"
        v-model="objetoFiltros[campo].seleccion"
        @keyup="iniciarTemporizadorCambiosEnFiltro"
        @click:clear="iniciarTemporizadorCambiosEnFiltro"
      />
      <!-- {{definicionCampos [campo]}} -->
      <!-- {{objetoFiltros[campo]}} -->
    </v-col>
    <span v-if="Object.keys (objetoFiltros).length == 0">
      <div class="caption font-weight-bold mt-1">{{ $t ('(No hay filtros diponibles)') }}</div>
    </span>
  </v-row>
</template>

<script>
import SelectorRangoFechasHoras from '@/components/SelectorRangoFechasHoras.vue'

export default {
  components: { SelectorRangoFechasHoras },
  props: {
    camposFiltrables: Array,
    definicionCampos: Object,
  },
  data() {
    return {
      objetoFiltros: {},
      temporizadorCambiosEnFiltros: null,
    }
  },
  methods: {
    actualizarArrayFiltros () {
      this.objetoFiltros = {};

      // nos aseguramos de que los campos por los que se quiere filtra son visibles en la tabla
      this.camposFiltrables.forEach ((campo) => {
        if (this.definicionCampos [campo]) {
          if (this.definicionCampos [campo].visibilidad === undefined || this.definicionCampos [campo].visibilidad == '' || /T/.test (this.definicionCampos [campo].visibilidad))
            this.$set (this.objetoFiltros, campo, { seleccion: null }); // lo asignamos con $set para que vue pueda saber cuando cambia la seleccion y así cambiar el color de fondo del control
        }
      });

      // cargamos los dominios de valores de cada campo
      Object.keys (this.objetoFiltros).forEach ((campo) => {
        if (this.definicionCampos [campo].dominio_valores) {
          this.objetoFiltros [campo].itemsSelect = [];
          Object.entries (this.definicionCampos [campo].dominio_valores).forEach(
            ([value, text]) => {
              let item = {};
              item.value = value;
              item.text = text;
              this.objetoFiltros [campo].itemsSelect.push(item);
            }
          );
          this.objetoFiltros [campo].itemsSelect.sort ((a, b) => a.text.localeCompare (b.text, undefined, { sensitivity: "base" }));
        }
      });
    },
    colorFondo (campo) {
      if (this.objetoFiltros[campo].seleccion != null)
        return "yellow lighten-3";
      else
        return "";
    },
    cambiosEnFiltro () {
      let filtros = {};
      Object.entries (this.objetoFiltros).forEach (([campo, datos]) => {
        if (!datos.seleccion)
          return;
        if (typeof datos.seleccion === 'object') {
          let objetoFiltro = {};
          let valorSeleccion = datos.seleccion.value;
          if ((this.definicionCampos [campo].tipo.toUpperCase() == 'DATETIME') && Array.isArray (valorSeleccion))
            objetoFiltro.valor = (valorSeleccion[0] ?? '') + '|' + (valorSeleccion[1] ?? '');
          else
            objetoFiltro.valor = JSON.parse (valorSeleccion);
          objetoFiltro.descripcion = this.definicionCampos[campo].titulo + ': ' + datos.seleccion.text;
          filtros [campo] = objetoFiltro;
        } else {
          let objetoFiltro = {};
          objetoFiltro.valor = datos.seleccion;
          objetoFiltro.descripcion = this.definicionCampos[campo].titulo + ': ' + datos.seleccion;
          filtros [campo] = objetoFiltro;
        }
      });
      this.$emit ("cambios", filtros);
      //this.logs (filtros);
    },
    iniciarTemporizadorCambiosEnFiltro () {
      if (this.temporizadorCambiosEnFiltros) clearTimeout(this.temporizadorCambiosEnFiltros);
      this.temporizadorCambiosEnFiltros = setTimeout(this.cambiosEnFiltro, 500);
    },
  },
  created() {
    this.actualizarArrayFiltros();
  }
}
</script>

<style>

</style>